/**
 * Content markup enhancements
 */

/**
 * Add identifiers for first and last block
 */
var gutenberg_content = document.querySelector(".wysiwyg");
if (gutenberg_content) {
  if (gutenberg_content.firstElementChild) {
    gutenberg_content.firstElementChild.classList.add("is-first-block");
  }
  if (gutenberg_content.lastElementChild) {
    gutenberg_content.lastElementChild.classList.add("is-last-block");
  }
}

/**
 * Make tables responsive
 */
(function () {
  var tables = document.querySelectorAll(".wysiwyg .wp-block-table table");
  for (var i = 0; i < tables.length; i++) {
    tables[i].classList.add("wp-block-table--responsive");

    var wrapper = document.createElement("div");
    wrapper.setAttribute("class", tables[i].getAttribute("class"));
    tables[i].removeAttribute("class");

    tables[i].parentNode.insertBefore(wrapper, tables[i]);
    wrapper.appendChild(tables[i]);
  }
})();

/**
 * Classic Editor image markup "polyfill"
 *
 * Wrap old images with captions to make alignment work and markup fit Gutenberg style
 * <figure class="wp-caption"><img></figure> => <div class="wp-block-image"><figure class="wp-caption"><img></figure></div>
 */
(function () {
  var figures = document.querySelectorAll(".wysiwyg .wp-caption");
  for (var i = 0; i < figures.length; i++) {
    if (!figures[i].parentNode.classList.contains("wp-block-image")) {
      var wrapper = document.createElement("div");
      wrapper.setAttribute("class", "wp-block-image");
      figures[i].parentNode.insertBefore(wrapper, figures[i]);
      wrapper.appendChild(figures[i]);
    }
  }
})();

/**
 * Classic Editor aligned image markup "polyfill"
 *
 * Wrap old aligned images without caption to make markup fit Gutenberg style
 * <p><img class="alignleft">Text<p> => <div class="wp-block-image"><figure class="alignleft"><img></figure></div><p>Text</p>
 */
(function () {
  var aligned = document.querySelectorAll(
    ".wysiwyg img.alignleft, .wysiwyg img.alignright"
  );
  for (var i = 0; i < aligned.length; i++) {
    var aligned_parent = aligned[i].parentNode;

    // if parent is paragraph, unwrap
    if (aligned_parent.nodeName === "P") {
      aligned_parent.parentNode.insertBefore(aligned[i], aligned_parent);
      if (aligned_parent.childNodes.length === 0) {
        aligned_parent.parentNode.removeChild(aligned_parent);
      }
    }

    // find and remove alignment from img
    var alignment = aligned[i].classList.contains("alignleft") ?
      "alignleft" : "alignright";
    aligned[i].classList.remove(alignment);

    // wrap with figure
    var figure = document.createElement("figure");
    figure.setAttribute("class", alignment);
    aligned[i].parentNode.insertBefore(figure, aligned[i]);
    figure.appendChild(aligned[i]);

    // wrap with .wp-block-image
    var div = document.createElement("div");
    div.setAttribute("class", "wp-block-image");
    figure.parentNode.insertBefore(div, figure);
    div.appendChild(figure);
  }
})();

/**
 * Add body class .has-no-hero-background
 */
if (document.querySelector(".hero--no-background")) {
  document.body.classList.add("has-no-hero-background");
}

/**
 * GLightbox support for native gallery and images
 * Requires link to media file from gallery/image settings.
 *
 * Try to find the a-tag parents to the images (the img-tag itself with the last two selectors), both gutenberg and classic editor.
 * Selectors:
 *   gutenberg gallery,
 *   classic gallery,
 *   gutenberg images AND classic images with caption,
 *   classic images without caption and with no or center align,
 *   classic images without caption and with left or right align
 */
var imgItems = document.querySelectorAll(
  ".blocks-gallery-item > figure > a, .gallery-item > .gallery-icon > a, .wp-block-image a, p > a > img, p > a > .wp-block-image"
);
// if found, add .glightbox-content class for the content images GLightbox instance
if (imgItems.length) {
  imgItems.forEach(function (item) {
    var formats = [".jpg", ".jpeg", ".png", ".gif", ".webp", ".avif"];
    // check (3 first selectors) href to verify media link
    if (item.href) {
      if (formats.some((el) => item.href.includes(el))) {
        item.classList.add("glightbox-content");
      }
      // check for figcaption and set as GLightbox description
      if (item.nextElementSibling) {
        if (item.nextElementSibling.nodeName.toLowerCase() === "figcaption") {
          item.dataset.description = item.nextElementSibling.innerText;
        }
      } else if (item.parentNode.nextElementSibling) {
        // classic gallery
        if (
          item.parentNode.nextElementSibling.nodeName.toLowerCase() ===
          "figcaption"
        ) {
          item.dataset.description = item.parentNode.nextElementSibling.innerText;
        }
      }
    } else if (item.parentNode.href) {
      // check (2 last selectors) href to verify media link
      if (formats.some((el) => item.parentNode.href.includes(el))) {
        item.parentNode.classList.add("glightbox-content");
      }
    }
  });
}
